var _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _mask2, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 32,
    viewBox: "0 0 95 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0239258 11.7719H10.9558V21.0154H0.0239258V11.7719Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73047 17.7173L5.48514 13.4765L7.22381 17.7173H3.73047ZM4.07813 11.772L-0.000488281 21.0155H2.46549L3.12958 19.4218H7.8403L8.5044 21.0155H10.9548L6.89215 11.772H4.07813Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5031 18.8536C16.1555 19.2969 15.4441 19.6157 14.7644 19.6157C13.6259 19.6157 12.8358 18.8259 12.8358 17.6755C12.8358 16.5115 13.6259 15.7213 14.7644 15.7213C15.4441 15.7213 16.1555 16.0405 16.5031 16.4835V18.8536ZM16.5031 15.1809C15.9026 14.5019 15.0489 14.1554 14.1476 14.1554C12.2033 14.1554 10.7646 15.4857 10.7646 17.6755C10.7646 19.9065 12.2193 21.1817 14.1476 21.1817C15.0645 21.1817 15.9026 20.8215 16.5031 20.1702V21.0154H18.5266V11.7719H16.5031V15.1809Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.148 14.3213L23.1565 18.9778L21.1642 14.3213H19.0146L22.0811 21.0151H24.247L27.3139 14.3213H25.148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0435 15.555C32.3713 15.555 32.877 16.4003 32.9246 17.0382H29.162C29.2572 16.3725 29.7945 15.555 31.0435 15.555ZM33.4303 19.1169C32.9402 19.5325 32.1025 19.7819 31.3912 19.7819C30.095 19.7819 29.3201 19.0755 29.1936 18.2299H34.8689V17.8417C34.8689 15.6522 33.3199 14.1553 31.0435 14.1553C28.7196 14.1553 27.0913 15.7213 27.0913 17.6618C27.0913 19.8096 28.846 21.1816 31.1699 21.1816C32.3553 21.1816 33.5411 20.8768 34.3156 20.2532L33.4303 19.1169Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6983 16.5114C38.0304 16.1095 38.6469 15.7213 39.437 15.7213C40.2907 15.7213 40.844 16.0404 40.844 16.9684V21.0153H42.8519V16.2898C42.8519 14.9869 42.0454 14.1553 40.3699 14.1553C39.1209 14.1553 38.1884 14.6821 37.6983 15.1948V14.3215H35.6904V21.0153H37.6983V16.5114Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0189 19.4215C47.9077 19.5187 47.6232 19.6155 47.3232 19.6155C46.8807 19.6155 46.6275 19.2967 46.6275 18.8807V15.8597H48.1765V14.3214H46.6275V12.4921H44.6039V14.3214H43.3394V15.8597H44.6039V19.3521C44.6039 20.5442 45.3629 21.1814 46.7695 21.1814C47.6076 21.1814 48.1453 20.9875 48.4453 20.7518L48.0189 19.4215Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0454 17.1351H58.025V21.0154H60.2857V11.7719H58.025V15.4029H53.0454V11.7719H50.8003V21.0154H53.0454V17.1351Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2558 17.0382C63.3506 16.3725 63.8879 15.555 65.1373 15.555C66.4647 15.555 66.9711 16.4003 67.0183 17.0382H63.2558ZM65.1373 14.1553C62.8133 14.1553 61.1851 15.7213 61.1851 17.6618C61.1851 19.8096 62.9397 21.1816 65.2637 21.1816C66.4491 21.1816 67.6348 20.8768 68.4094 20.2532L67.5244 19.1169C67.0339 19.5325 66.1958 19.7819 65.4845 19.7819C64.1887 19.7819 63.4142 19.0755 63.2874 18.2299H68.9622V17.8417C68.9622 15.6522 67.4136 14.1553 65.1373 14.1553Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.595 15.7349C74.2747 15.7349 74.986 16.0541 75.3337 16.4971V18.8535C74.986 19.2968 74.2747 19.6156 73.595 19.6156C72.4564 19.6156 71.6663 18.8258 71.6663 17.6755C71.6663 16.5114 72.4564 15.7349 73.595 15.7349ZM72.9781 21.1816C73.8955 21.1816 74.7332 20.8214 75.3337 20.1701V21.0153H77.3576V14.3215H75.3337V15.1808C74.7332 14.5018 73.8795 14.1553 72.9781 14.1553C71.0338 14.1553 69.5952 15.4856 69.5952 17.6755C69.5952 19.9064 71.0498 21.1816 72.9781 21.1816Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7168 21.0158H80.7247V11.7719H78.7168V21.0158Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2089 19.4215C86.0981 19.5187 85.814 19.6155 85.5136 19.6155C85.0707 19.6155 84.8179 19.2967 84.8179 18.8807V15.8597H86.3673V14.3214H84.8179V12.4921H82.7944V14.3214H81.5298V15.8597H82.7944V19.3521C82.7944 20.5442 83.5533 21.1814 84.9599 21.1814C85.7984 21.1814 86.3357 20.9875 86.6358 20.7518L86.2089 19.4215Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4339 16.5115C89.7823 16.1096 90.3984 15.7213 91.1729 15.7213C92.043 15.7213 92.5959 16.0128 92.5959 16.9408V21.0154H94.6035V16.2618C94.6035 14.9592 93.7977 14.1554 92.1219 14.1554C90.8733 14.1554 89.9243 14.6822 89.4339 15.1949V11.7719H87.4268V21.0154H89.4339V16.5115Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5962 8.39003L68.6567 8.72388L69.6079 8.59185L69.5475 8.258L68.5962 8.39003Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9268 4.8171L68.8663 4.48325L67.915 4.61562L67.9751 4.94948L68.9268 4.8171Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1131 6.33596L70.4943 6.28328L70.3496 5.48251L69.9688 5.53553L70.1131 6.33596Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1904 5.92157L66.8096 5.97459L66.9543 6.77501L67.3348 6.72233L67.1904 5.92157Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 0,
    width: 13,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.061 0.340332H74.0675V6.23473H62.061V0.340332Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4333 4.49814C62.6358 5.62079 63.8383 6.38666 65.1189 6.20879L66.8092 5.97414L67.19 5.92112L68.1265 5.79113L67.9743 4.94932L67.9142 4.61547L67.6501 3.15487C67.4476 2.03188 66.2446 1.26635 64.964 1.44388L62.6717 1.76234C62.2772 1.81707 62.0076 2.14237 62.07 2.48853L62.4333 4.49814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0791 5.65935L69.9711 5.53552L70.3519 5.4825L72.0875 5.24169C73.3684 5.06382 74.2428 4.00925 74.0396 2.88592L73.6767 0.876308C73.6139 0.529801 73.2428 0.293094 72.8471 0.348166L70.5548 0.666625C69.2738 0.844497 68.3998 1.89907 68.6031 3.02206L68.8669 4.48334L68.9273 4.81719L69.0791 5.65935Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2702 6.5921L67.3334 6.72243L66.9529 6.7751L65.5869 6.96495C64.6364 7.09698 63.9883 7.87894 64.1389 8.7122L64.4624 10.5043C64.5186 10.8135 64.8498 11.0245 65.203 10.9756L67.0138 10.7242C68.0931 10.5744 68.829 9.68604 68.6581 8.74025L68.6553 8.72417L68.5948 8.39032L68.2702 6.5921Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2217 6.45988L69.5463 8.25809L69.6068 8.59195L69.6095 8.60871C69.7808 9.55485 70.7945 10.2003 71.8738 10.0505L73.685 9.79908C74.0381 9.74982 74.2793 9.45907 74.2235 9.14951L73.8996 7.35711C73.749 6.52385 72.8563 5.95534 71.9058 6.08737L70.4945 6.28338L70.1133 6.33605L69.2217 6.45988Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5651 26.2065C37.404 26.2065 38.0841 26.6337 38.4017 27.1704L39.7845 26.5742C39.2519 25.7492 38.2885 24.9542 36.5651 24.9542C34.3547 24.9542 32.5977 26.3457 32.5977 28.3827C32.5977 30.4204 34.3547 31.8115 36.5651 31.8115C38.2885 31.8115 39.2406 31.0063 39.7845 30.1816L38.4017 29.5953C38.0841 30.1419 37.404 30.5596 36.5651 30.5596C35.2501 30.5596 34.2528 29.6353 34.2528 28.3827C34.2528 27.1308 35.2501 26.2065 36.5651 26.2065Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8474 28.8403C41.9149 28.3635 42.3004 27.7772 43.1962 27.7772C44.1483 27.7772 44.5112 28.383 44.5451 28.8403H41.8474ZM43.1962 26.7733C41.5297 26.7733 40.3623 27.8966 40.3623 29.2877C40.3623 30.828 41.6203 31.8118 43.2867 31.8118C44.137 31.8118 44.9872 31.5932 45.5424 31.1462L44.908 30.331C44.5564 30.6293 43.9555 30.8079 43.4456 30.8079C42.5161 30.8079 41.9605 30.3013 41.87 29.6951H45.9392V29.4167C45.9392 27.8466 44.8284 26.7733 43.1962 26.7733Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3381 26.7733C49.4426 26.7733 48.7739 27.1509 48.4227 27.5186V26.8926H46.9829V31.6924H48.4227V28.4627C48.6607 28.1747 49.1028 27.8966 49.6693 27.8966C50.2815 27.8966 50.6784 28.1251 50.6784 28.7907V31.6924H52.1178V28.3036C52.1178 27.3698 51.5399 26.7733 50.3381 26.7733Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7789 30.6889C55.4617 30.6889 55.2803 30.4604 55.2803 30.1625V27.9959H56.3911V26.8927H55.2803V25.5809H53.8292V26.8927H52.9224V27.9959H53.8292V30.5001C53.8292 31.3549 54.3735 31.8119 55.3825 31.8119C55.983 31.8119 56.3685 31.673 56.5839 31.5041L56.278 30.5497C56.198 30.6195 55.9943 30.6889 55.7789 30.6889Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8178 27.5482V26.8924H57.3784V31.6922H58.8178V28.5224C59.0562 28.2142 59.691 27.9853 60.1671 27.9853C60.3259 27.9853 60.4617 27.9956 60.5639 28.0154V26.7833C59.8838 26.7833 59.2037 27.1209 58.8178 27.5482Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2237 30.1422C64.9744 30.4603 64.4644 30.6888 63.9766 30.6888C63.1604 30.6888 62.5938 30.1227 62.5938 29.2973C62.5938 28.4627 63.1604 27.9062 63.9766 27.9062C64.4644 27.9062 64.9744 28.1347 65.2237 28.4528V30.1422ZM65.2237 27.5087C64.7929 27.0216 64.1811 26.7733 63.5346 26.7733C62.1404 26.7733 61.1084 27.7276 61.1084 29.2973C61.1084 30.8975 62.1514 31.8118 63.5346 31.8118C64.1924 31.8118 64.7929 31.5536 65.2237 31.0863V31.6924H66.6748V26.8926H65.2237V27.5087Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6417 26.2065C75.4806 26.2065 76.1611 26.6337 76.4783 27.1704L77.8612 26.5742C77.3286 25.7492 76.3648 24.9542 74.6417 24.9542C72.4313 24.9542 70.6743 26.3457 70.6743 28.3827C70.6743 30.4204 72.4313 31.8115 74.6417 31.8115C76.3648 31.8115 77.3172 31.0063 77.8612 30.1816L76.4783 29.5953C76.1611 30.1419 75.4806 30.5596 74.6417 30.5596C73.3272 30.5596 72.3291 29.6353 72.3291 28.3827C72.3291 27.1308 73.3272 26.2065 74.6417 26.2065Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5553 30.1422C82.3064 30.4603 81.796 30.6888 81.3087 30.6888C80.4924 30.6888 79.9255 30.1227 79.9255 29.2973C79.9255 28.4627 80.4924 27.9062 81.3087 27.9062C81.796 27.9062 82.3064 28.1347 82.5553 28.4528V30.1422ZM82.5553 27.5087C82.125 27.0216 81.5128 26.7733 80.8666 26.7733C79.4725 26.7733 78.4404 27.7276 78.4404 29.2973C78.4404 30.8975 79.4834 31.8118 80.8666 31.8118C81.5241 31.8118 82.125 31.5536 82.5553 31.0863V31.6924H84.0064V26.8926H82.5553V27.5087Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8744 27.5482V26.8924H85.4346V31.6922H86.8744V28.5224C87.112 28.2142 87.7468 27.9853 88.2232 27.9853C88.3817 27.9853 88.5174 27.9956 88.6197 28.0154V26.7833C87.9396 26.7833 87.2595 27.1209 86.8744 27.5482Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6487 28.8403C90.717 28.3635 91.1021 27.7772 91.9976 27.7772C92.9504 27.7772 93.3133 28.383 93.3469 28.8403H90.6487ZM94.7414 29.4167C94.7414 27.8466 93.6305 26.7733 91.9976 26.7733C90.3315 26.7733 89.1641 27.8966 89.1641 29.2877C89.1641 30.828 90.422 31.8118 92.0885 31.8118C92.9391 31.8118 93.7889 31.5932 94.3446 31.1462L93.7097 30.331C93.3582 30.6293 92.7577 30.8079 92.2473 30.8079C91.3175 30.8079 90.7623 30.3013 90.6717 29.6951H94.7414V29.4167Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.761528dc89d263f804b22597f2044b4c.svg";
export { ForwardRef as ReactComponent };